<div class="row customer-invoice">
  <div class="col-12 offset-lg-2 col-lg-8 customer-invoice__header">
    <h3 class="customer-invoice__title"
        *appApplyIfNotEmpty="translationService.getTranslation('invoices')"
        [innerHTML]="translationService.getTranslation('invoices')"></h3>
  </div>
  <div class="col-12 offset-lg-2 col-lg-8 mb-5 customer-invoice__description"
       [innerHTML]="translationService.getTranslation('invoices_description')">
  </div>
</div>

<div class="row customer-invoice__paginator-row">
  <div class="col-12 offset-lg-2 col-lg-8 customer-invoice__paginator-col">
    <mat-paginator class="float-start mb-3 customer-invoice__paginator" [pageSize]="pageSize" [length]="totalAmount"
                   [disabled]="isLoading"
                   [hidePageSize]="true" [showFirstLastButtons]="false" (page)="loadInvoices($event)">
    </mat-paginator>
  </div>
</div>

<div id="invoice-page" class="customer-invoice__page">
  @if (!isLoading) {
    <div class="row customer-invoice__list">
      @for (invoice of currentInvoices; track invoice) {
        <div [className]="(hasCustomResponsivClasses() ? getCustomResponsivClasses() : 'col-12 offset-lg-2 col-lg-8' ) + ' mb-4 customer-invoice__item'">
          <mat-card appearance="outlined" class="pointer h-100 customer-invoice__card">
            <mat-card-header class="mb-3 customer-invoice__card-header">
              <mat-card-title
                class="customer-invoice__card-title"
                [innerHTML]="translationService.getTranslation(invoice.credit ? 'invoice_creditOf' : 'invoice_of') + ( invoice.invoiceDate | date: translationService.getTranslation('dateFormat'))">
              </mat-card-title>
              <mat-card-subtitle
                class="customer-invoice__card-subtitle customer-invoice__card-subtitle--number"
                [innerHTML]="translationService.getTranslation('invoice_number') + ': ' + invoice.invoiceNo">
              </mat-card-subtitle>
              <mat-card-subtitle
                class="customer-invoice__card-subtitle customer-invoice__card-subtitle--amount"
                [innerHTML]="translationService.getTranslation(invoice.credit ? 'invoice_creditAmount' : 'invoice_invoiceAmount') + ': ' + ( invoice.invoiceAmount | currency )">
              </mat-card-subtitle>
            </mat-card-header>
            @if (invoice.hasDocument) {
              <embed class="customer-invoice__document" [src]="invoice.invoiceDocumentUrl | safeResource"
                     type="application/pdf">
            }
          </mat-card>
        </div>
      }
    </div>
  }
</div>
